import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import auth from '../../services/auth';
import '../../demo/demo.css';
import GridContainer from "../Grid/GridContainer.js";
import GridItem from "../Grid/GridItem.js";
import Card from "../Card/Card.js";
import CardHeader from "../Card/CardHeader.js";
import CardIcon from "../Card/CardIcon.js";
import CardBody from "../Card/CardBody.js";
import CardFooter from "../Card/CardFooter.js";
import Button from "../CustomButtons/Button.js";

// @material-ui/icons
import Icon from "@material-ui/core/Icon";
import "react-datepicker/dist/react-datepicker.css";
import checatoken from '../checatoken';
import DateRange from "@material-ui/icons/DateRange";
import {Doughnut} from 'react-chartjs-2';
import swal from 'sweetalert';
import Table from "components/Table/Table.js";
import FormControl from "@material-ui/core/FormControl";
import Datetime from "react-datetime";

export const numberFormat = (value) =>
    new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);

class ContasPagar extends Component {

    constructor (props) {
        super(props)
        this.state = {startDate: new Date(),
                    };
            
              this.handleChange = this.handleChange.bind(this);
              this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {endDate: new Date(),
                 startDate: new Date(),
                 titulos: {
                    ValorPago: 0,
                    ValorTotal: 0,
                    aPagar: 0,
                    Qtde: 0
                },
                TabelaPag: [],
                TabelaPagAtrasado: []
                };
            
              this.handleChangef = this.handleChangef.bind(this);
              this.handleSubmit = this.handleSubmit.bind(this);
              this.getDadosAtrasados = this.getDadosAtrasados.bind(this);

              this.state.startDate.setMonth(this.state.startDate.getMonth() - 1);
    }
      
   
    
    formatDateForApi(value) {
        if (!value) {
            return "";
        }

        if (value._isAMomentObject && value.format) {
            return value.format('DD/MM/YYYY');
        }

        const date = value instanceof Date ? value : new Date(value);

        if (isNaN(date.getTime())) {
            return "";
        }

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    formatDateFromApi(dateString) {
        if (!dateString) {
            return '';
        }
        
        // Se a data já vem formatada como DD/MM/YYYY, retorna diretamente
        if (typeof dateString === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
            return dateString;
        }
        
        // Se vem como ISO (YYYY-MM-DD), formata sem conversão de fuso horário
        if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateString)) {
            const [year, month, day] = dateString.split('T')[0].split('-');
            return `${day}/${month}/${year}`;
        }
        
        // Para outros formatos, tenta extrair componentes sem conversão de fuso
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return '';
        }
        
        // Usa UTC para evitar problemas de fuso horário
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        
        return `${day}/${month}/${year}`;
    }


    handleChange(date) {
            this.setState({ startDate: date })
  
    }
    
    handleChangef(date) {
        this.setState({ endDate: date })

    }

  
      handleSubmit(e) {
        e.preventDefault();
        this.getpagarresumo();
        this.getchartpagar();
        this.getDadosTabela();
        this.getDadosAtrasados();
      }

      async getpagarresumo() {
        const chave = localStorage.getItem('lukos-token');
        await auth.get('financeiro/contaspagarcard', {
            headers: {token: chave},
            params:   {dataIni : this.state.startDate, dataFim: this.state.endDate}
        }).then( res => {
                            console.log(res.data)
                            this.setState({ titulos: res.data });
                        }
        )        
    };      

    async getchartpagar(){
        const chave = localStorage.getItem('lukos-token');
        await auth.get('financeiro/contaspagargraf', {
            headers: {token: chave},
            params:   {dataIni : this.state.startDate, dataFim: this.state.endDate}
        }).then( res => {
                            console.log(res.data)
                            this.setState({ datapagarChart :  {
                                labels: res.data.contapagar[0].labels,
                                datasets: res.data.contapagar[1].datasets,
                                options: res.data.contapagar[2].options
                                                        } 
                                                    })                            
                        }
        )        
    }      

    async getDadosTabela() {
        const chave = localStorage.getItem('lukos-token');
        await auth.get('/financeiro/contaspagartab', {
            headers: {token: chave},
            params:   {dataIni : this.state.startDate, dataFim: this.state.endDate}
        }).then( res => {
            this.setState({ TabelaPag: res.data})
                
            }
        )
        .catch(function (error) {
                swal("OPS!! Sem dados", "Não tem dados no período indicado, tente mudar as datas no filtro", "warning");
            })  
    };


    async componentDidMount() {
        await checatoken();
        await this.getpagarresumo();
        await this.getchartpagar();
        await this.getDadosTabela();
        await this.getDadosAtrasados();
    };
    async getDadosAtrasados() {
        const chave = localStorage.getItem('lukos-token');
        const dataIni = this.formatDateForApi(this.state.startDate);
        const dataFim = this.formatDateForApi(this.state.endDate);

        await auth.get('/financeiro/ContaspagarAtrasado', {
            headers: {token: chave},
            params: { dataIni, dataFim }
        }).then( res => {
            const titulos = Array.isArray(res.data) ? res.data : [res.data];
            const tabelaFormatada = titulos.map((item) => [
                item.Titulo,
                numberFormat(item.ValorTotal || 0),
                this.formatDateFromApi(item.DataVencimento),
                item.UnidadeOperacional || '',
                item.Fornecedor || '',
                item.Categoria || '',
                item.SubCategoria || ''
            ]);
            this.setState({ TabelaPagAtrasado: tabelaFormatada })
        })
        .catch(function (error) {
                swal("OPS!! Sem dados", "Não tem títulos em atraso", "warning");
            })  
    };


    render() {
        const isLogged = !!localStorage.getItem('lukos-token');
        if (isLogged === false) {
            return(<Redirect to="/login" />)
          }
          else
          {

        
        return (<div>
            <GridContainer>
                <GridItem xs={12} sm={4} md={4} >
                    <Card>
                        <CardHeader color="warning" stats icon>
                            <CardIcon color="warning">
                                <Icon>sentiment_satisfied</Icon>
                            </CardIcon>
                            <br></br>
                            <h6>Selecione o período</h6>
                        </CardHeader>
                        <CardBody>
                        <GridContainer> 
                        <GridItem xs={12} sm={6} md={6}>
                        <div>
                            <label>Data Inicial: </label>
                                <FormControl fullWidth>
                                    <Datetime
                                    //   timeFormat={false}
                                    //   inputProps={{ placeholder: "Date Picker Here" }}
                                    timeFormat={false}
                                    name="startDate"
                                    id="startDate" 
                                    locale="pt-br"
                                    dateFormat="DD/MM/yyyy"
                                    closeOnSelect="true"
                                    input="false"
                                    defaultValue = {this.state.startDate}
                                    onChange={ this.handleChange }
                                    inputProps={{ placeholder: "Date Picker Here" }}
                                    />
                                </FormControl>                                
                        </div>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6}>
                         <div>
                            <label>Data Final : </label>
                            <FormControl fullWidth>
                                    <Datetime
                                    //   timeFormat={false}
                                    //   inputProps={{ placeholder: "Date Picker Here" }}
                                    timeFormat={false}
                                    name="endDate"
                                    id="endDate" 
                                    locale="pt-br"
                                    dateFormat="DD/MM/yyyy"
                                    closeOnSelect="true"
                                    defaultValue = {this.state.endDate}
                                    onChange={ this.handleChangef }
                                    inputProps={{ placeholder: "Date Picker Here" }}
                                    />
                                </FormControl>    
                                {/* <DatePicker
                                name="endDate"
                                id="endDate"
                                selected={ this.state.endDate }
                                onChange={ this.handleChangef}
                                /> */}
                        </div> 
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <br></br>
                        <Button color="primary" round onClick={ this.handleSubmit}>

                                Filtrar
                                
                            </Button>
                        </GridItem>
                        </GridContainer>
                        </CardBody>
                        <CardFooter>

                         </CardFooter>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={8} md={8} >
                <GridContainer>
                <GridItem xs={12} sm={6} md={6} >
                    <Card>
                        <CardHeader color="info" stats icon>
                            <CardIcon color="info">
                                <Icon>attach_money</Icon>
                            </CardIcon>
                            <br></br>
                            <h6>Valor Total</h6>
                            <h3 className='makeStyles-cardTitle-91'>
                            {numberFormat(this.state.titulos.ValorTotal)}  
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                                <DateRange />
                                Valor Total no período
                        </CardFooter>
                    </Card>              
                </GridItem>                
                <GridItem xs={12} sm={6} md={6} >
                    <Card>
                        <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                                <Icon>attach_money</Icon>
                            </CardIcon>
                            <br></br>
                            <h6>Valor Pago</h6>
                            <h3 className='makeStyles-cardTitle-91'>
                            {numberFormat(this.state.titulos.ValorPago)}  
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                                <DateRange />
                                Valor pago no Período
                        </CardFooter>
                    </Card>              
                </GridItem>                
                <GridItem xs={12} sm={6} md={6} >
                    <Card>
                        <CardHeader color="danger" stats icon>
                            <CardIcon color="danger">
                                <Icon>attach_money</Icon>
                            </CardIcon>
                            <br></br>
                            <h6>Restante a pagar</h6>
                            <h3 className='makeStyles-cardTitle-91'>
                            {numberFormat(this.state.titulos.aPagar)}  
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                                <DateRange />
                                Valor a pagar no período
                        </CardFooter>
                    </Card>              
                    </GridItem>                
                    <GridItem xs={12} sm={6} md={6} >
                    <Card>
                        <CardHeader color="primary" stats icon>
                            <CardIcon color="primary">
                                <Icon>show_chart</Icon>
                            </CardIcon>
                            <br></br>
                            <h6>Qtde de Titulos</h6>
                            <h3 className='makeStyles-cardTitle-91'>
                                {this.state.titulos.Qtde} 
                            </h3>
                        </CardHeader>
                        <CardFooter stats>
                                <DateRange />
                                Quantidade de titulos no período
                        </CardFooter>
                    </Card>              
                    </GridItem>                
                    </GridContainer>
            </GridItem>                
            </GridContainer>
            <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className="makeStyles-cardTitleWhite-87">Pagamento por Categoria  </h4>
                        </CardHeader>
                        <CardBody>
                          <Doughnut data={this.state.datapagarChart} height={255}   options={{legend: { display: true}}}/>
                        </CardBody>
                        <CardFooter>
                        Pagamento por Categoria
                        </CardFooter>
                    </Card>
                </GridItem>                    
                <GridItem xs={12} sm={6} md={6}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className="makeStyles-cardTitleWhite-87">Pagamento por Categoria </h4>
                        </CardHeader>
                        <CardBody>
                        <Table
                            tableHeaderColor="primary"
                            tableHead={["Categoria", "Valor Total"]}
                            tableData={this.state.TabelaPag}
                        />
                        </CardBody>
                        <CardFooter>
                        Pagamento de titulos por Categoria
                        </CardFooter>
                    </Card>
                    </GridItem>                    
                    <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="danger">
                            <h4 className="makeStyles-cardTitleWhite-87">Detalhe dos títulos em Aberto</h4>
                        </CardHeader>
                        <CardBody>
                        <Table
                            tableHeaderColor="danger"
                            tableHead={[
                                "Título",
                                "Valor Total",
                                "Data de Vencimento",
                                "Unidade Operacional",
                                "Fornecedor",
                                "Categoria",
                                "Subcategoria"
                            ]}
                            tableData={this.state.TabelaPagAtrasado}
                        />
                        </CardBody>
                        <CardFooter>
                        Detalhamento dos títulos no período selecionado
                        </CardFooter>
                    </Card>
                    </GridItem>                    
                    </GridContainer>

        </div>
        )}

    };


}


export default ContasPagar;